module.exports = __webpack_public_path__ + "static/banner-mobile-244f5003fadc99dfe3cf3713bc358d1b.png";